/*
* Подпись события в чипах календаря
*
* По макету в чипе стоит только тип и номер («План. №49», «НС №56»),
* а название события уходит в тултип.
* На мобиле буква типа с точкой: А. аудиты, Н. НС, З. заявка и задача (различие по цвету), П. ППУ.
*/

interface ICalendarEventLabelSource {
  id: number | string
  extendedProps?: {
    calendar?: string
    audit_type?: string
    source?: string
  }
}

const auditTypePrefixes: Record<string, string> = {
  planned: 'План.',
  unplanned: 'Внеплан.',
}

const calendarPrefixes: Record<string, string> = {
  'аудиты': 'Проверка',
  'нежелательные события': 'НС',
  'заявки': 'Заяв.',
  'заявка': 'Заяв.',
  'тикеты': 'Заяв.',
  'задачи': 'Задача',
  'задача': 'Задача',
  'записи': 'Задача',
  'предложения по улучшению': 'ППУ',
  'ппу': 'ППУ',
}

const sourcePrefixes: Record<string, string> = {
  Audit: 'Проверка',
  AdverseEvent: 'НС',
  Ticket: 'Заяв.',
  CalendarEvent: 'Задача',
  ResponsibilityEntry: 'Задача',
  ImprovementSuggestion: 'ППУ',
  Improvement: 'ППУ',
}

const compactLetters: Record<string, string> = {
  'План.': 'А',
  'Внеплан.': 'А',
  'Проверка': 'А',
  'НС': 'Н',
  'Заяв.': 'З',
  'Задача': 'З',
  'ППУ': 'П',
}

const getPrefix = (event: ICalendarEventLabelSource): string => {
  const { audit_type: auditType, calendar, source } = event.extendedProps ?? {}

  return (auditType && auditTypePrefixes[auditType])
    || (source && sourcePrefixes[source])
    || (calendar && calendarPrefixes[calendar.trim().toLocaleLowerCase('ru-RU')])
    || ''
}

export const getCalendarEventLabel = (
  event: ICalendarEventLabelSource,
  options?: { compact?: boolean },
): string => {
  const prefix = getPrefix(event)

  if (options?.compact) {
    const letter = (prefix && compactLetters[prefix]) || ''

    return letter ? `${letter}.${event.id}` : String(event.id)
  }

  return prefix ? `${prefix} №${event.id}` : `№${event.id}`
}
